import RateCodeControl from 'features/CustomCampaigns/RateCodeFilter/RateCodeControl'
import RateCodeRow from 'features/CustomCampaigns/RateCodeFilter/RateCodeRow'
import { useEffect, useState } from 'react'

import styles from './AvailabCodes.module.scss'

const AvailableCodes = ({
  rateCodes,
  selectedRateCodes,
  onClickCode,
  addAllCodes,
  filterValue,
  setFilterValue,
  onChangeTrackingDropdown,
  trackingCodes,
  count,
  getAllRateCodes,
  onClickGetAll
}) => {
  const [tempValue, setTempValue] = useState(filterValue)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFilterValue(tempValue)
    }, 500)

    return () => clearTimeout(timeout)
  }, [tempValue]) // eslint-disable-line

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.titleHolder}>
          <h2 className={styles.title}>Available rate codes ({count})</h2>
          <p className={styles.titleDescription}>From last 2 years</p>
        </div>
        <div className={styles.filterHolder}>
          <input
            type="search"
            placeholder="Search"
            data-testid="search-input"
            value={tempValue}
            onChange={e => setTempValue(e.target.value)}
          />
          <select onChange={onChangeTrackingDropdown}>
            <option value="">Any tracking info</option>
            <option value="Unknown">No tracking info</option>
            {trackingCodes.map(t => (
              <option value={t} key={t}>
                {t}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={styles.contentHolder}>
        {!rateCodes && (
          <div className={styles.notFoundHolder}>
            <span className={styles.notFoundText}>No rate codes found</span>
          </div>
        )}
        {rateCodes &&
          Object.keys(rateCodes).map(rateCode => (
            <RateCodeRow
              onClick={() => onClickCode({ rateCode, count: rateCodes[rateCode] })}
              rateCode={rateCode}
              key={rateCode + rateCodes?.[rateCode]}
              count={rateCodes[rateCode]}
              action={Object.keys(selectedRateCodes).includes(rateCode) ? 'added' : 'add'}
            />
          ))}
      </div>
      {count > 100 && !getAllRateCodes && (
        <button className={styles.getAllButton} onClick={onClickGetAll}>
          Showing first 100 results.
          <span className={styles.getAllButtonLink}> Click here to see all results</span>
        </button>
      )}
      {Object.keys(rateCodes).length > 1 && (
        <RateCodeControl action="add" onClick={addAllCodes} />
      )}
    </div>
  )
}

export default AvailableCodes
